import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import { CDropDown } from "@appcues/component-library";
import { selectProfileAttributeDropdownOptions } from "reducers/account/profileAttributes";

import ProfileAttributeMenuList from "./ProfileAttributeMenuList";
import ProfileAttributeOption from "./ProfileAttributeOption";

export const SelectProfileAttribute = ({
  value,
  options,
  readOnly,
  onChange,
  placeholder = "Pick an option",
  className
}) => {
  const handleChange = selectedValue => void onChange({ value: selectedValue });
  return (
    <div className={`Select select-profile-attribute ${className}`}>
      <CDropDown
        clearable={false}
        value={value}
        options={options}
        autosize={false}
        onChange={handleChange}
        placeholder={value || placeholder}
        components={{
          MenuList: ProfileAttributeMenuList,
          Option: ProfileAttributeOption
        }}
        isDisabled={readOnly}
        isSearchable
      />
    </div>
  );
};

SelectProfileAttribute.propTypes = {
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string,
          isAutoProp: PropTypes.bool
        })
      )
    })
  ),
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};

const mapStateToProps = state => ({
  options: selectProfileAttributeDropdownOptions(state)
});

// language=SCSS prefix=dummy{ suffix=}
export default connect(mapStateToProps)(styled(SelectProfileAttribute)`
  position: relative;
  min-width: 225px;
  span.stale {
    color: ${props => props.theme["$gray-20"]};
  }
`);
